export const INITIAL_VALUES = {
  email: '',
  name: '',
  phone: '',
};
